import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../styles/const/colors'
import { phonesDown } from '../../../styles/const/breakpoints'

const useTotalsStyles = createUseStyles({
  pdfGenerateBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 37,
    [`@media screen and (${phonesDown})`]: {
      height: 32
    }
  },
  icon: {
    marginLeft: [0, '!important'],
    margin: '0 10px',
    color: darkGrey,
    maxWidth: 20,
    '&:hover': {
      color: darkGrey
    }
  },
  [`@media screen and (${phonesDown})`]: {
    pdfGenerateBtn: {
      height: 32
    },
    icon: {
      maxWidth: 18
    }
  }
})

export default useTotalsStyles
